import { observable, action, computed } from 'mobx';
import FirebaseDocumentService from '../services/impl/firebase/FirebaseDocumentService';


class ContentViewerStore {
  rootStore:any = null;
  @observable docsPage:any = [];
  documentService:any = {};

  constructor(rootStore:any) {
    this.rootStore = rootStore;
    this.documentService = new FirebaseDocumentService();
  }

  @action loadDocPage = async (shareCode: string) => {
    let imageArray: any[] = []
    try {
      const docs = await this.documentService.getSharedDocument(shareCode);
      await docs.pages.forEach((child:any) => {
        imageArray.push(child.url)
      });
      this.docsPage = imageArray;
    }
    catch(e) {
      console.log(e);
    }
  }
}

export default ContentViewerStore;